import React from 'react';
import StickyWindow from './components/stickyWindow';
import { MapPropertyList } from '../../../../components/UI/modules';

class MapPropertyMobileWindowView {
  constructor({ element, map, stickyWindowElement }) {
    this.element = element;
    this.map = map;
    this.stickyWindowElement = stickyWindowElement;
    this.window = null;
    this.addMapEvents();
  }

  handleMapDragStart = (e) => {
    this.hideWindow();
  }

  handleMapClick = (e) => {
    if (e.placeId) {
      e.stop();
    }
    this.hideWindow();
  }

  handleWindowOverlayClick = (e) => {
    if (this.window) {
      this.window.show();
    }
    this.element.dispatchEvent(new CustomEvent('overlay:click', {
      detail: {}
    }));
  }

  handleWindowCloseClick = (e) => {
    if (this.window) {
      this.window.close();
    }
    this.element.dispatchEvent(new CustomEvent('close:click', {
      detail: {}
    }));
  }

  addMapEvents() {
    // close any instance of infoWindow if click the map
    this.googleHandleMapClick = window.google.maps.event.addListener(this.map, 'click', this.handleMapClick);
    this.googleHandleMapDragStart = window.google.maps.event.addListener(this.map, 'dragstart', this.handleMapDragStart);
  }

  removeMapEvents() {
    window.google.maps.event.removeListener(this.googleHandleMapClick);
    window.google.maps.event.removeListener(this.googleHandleMapDragStart);
  }

  openWindow({ propertyGroup }) {
    if (this.window) {
      this.window.close();
    }

    this.window = new StickyWindow({
      element: this.stickyWindowElement,
      contentElement: <MapPropertyList properties={propertyGroup.properties} mobile={true} />
    });

    this.window.open();
    this.window.on('overlay:click', this.handleWindowOverlayClick);
    this.window.on('close:click', this.handleWindowCloseClick);

    if (this.swiper) {
      this.swiper.update();
    }
  }

  hideWindow() {
    if (this.window) {
      this.window.hide();
    }
  }

  closeWindow() {
    if (this.window) {
      this.window.close();
    }
  }

  on(event, callback) {
    this.element.addEventListener(event, callback);
  }

  off(event, callback) {
    this.element.removeEventListener(event, callback);
  }

  destroy() {
    this.removeMapEvents();
    if (this.window) {
      this.window.off('overlay:click', this.handleWindowOverlayClick);
    }
  }
}

export default MapPropertyMobileWindowView;
